document.addEventListener('click', function (e) {
  const btn = e.target.closest('.quantity-preset');
  if (!btn) return;

  const form = btn.closest('form');
  if (!form) return;

  const quantity = Number(btn.dataset.quantity);

  // UI state scoped to form
  form.querySelectorAll('.quantity-preset').forEach(b => {
    b.classList.remove('product-quantity__card--active');
  });
  btn.classList.add('product-quantity__card--active');

  const input = form.querySelector('input[name="quantity"]');
  if (!input) return;

  input.value = quantity;

  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

const overlay = document.querySelector('.productFormOverlay');

document.addEventListener('submit', function (e) {
  if (e.target.matches('.productForm form')) {
    setTimeout(() => {
      closeAllForms();
    }, 300);
  }
});

function closeAllForms() {
  document.querySelectorAll('.productForm').forEach(f => f.classList.remove('open'));

  overlay?.classList.remove('active');
  document.body.classList.remove('no-scroll');
}

function handleize(str) {
  return str
    .toLowerCase()
    .normalize('NFD')                 // remove accents
    .replace(/[\u0300-\u036f]/g, '')  // remove diacritics
    .replace(/[^a-z0-9]+/g, '-')      // replace non-alphanumeric with -
    .replace(/^-+|-+$/g, '');         // trim -
}


document.addEventListener('change', function (e) {
  const radio = e.target.closest('[data-use="var-selector"]');
  if (!radio) return;

  const formId = radio.getAttribute('form');
  const form = document.getElementById(formId);
  if (!form) return;

  const hiddenInput = form.querySelector('input[name="id"]');
  if (!hiddenInput) return;

  hiddenInput.value = radio.value;
});

/*
document.addEventListener('change', function (e) {
  const radio = e.target.closest('[data-use="var-selector"]');
  if (!radio) return;

  const form = radio.closest('form');
  
  console.log('Radio clicked:', radio.value);
  console.log('Form found:', form?.id);
  console.log('Hidden input found:', form?.querySelector('input[name="id"]')?.value);
  document.querySelector('[data-use="var-selector"]').closest('form')
  javascriptdocument.querySelector('[data-use="var-selector"]').parentElement
// keep calling .parentElement chain to see the actual DOM structure
});
*/

document.addEventListener('change', function (e) {
  const radio = e.target.closest('[data-use="var-selector"]');
  if (!radio) return;

  const form = radio.closest('form');
  if (!form) return;

  const basePrice = parseInt(radio.dataset.durationPrice, 10); // in cents
  if (!basePrice) return;

  const discounts = { 1: 0, 2: 5, 3: 10 }; // match your Liquid % off

  form.querySelectorAll('.quantity-preset').forEach(card => {
    const qty = parseInt(card.dataset.quantity, 10);
    const discount = discounts[qty] ?? 0;
    const multiplier = (100 - discount) / 100;

    const raw = basePrice * qty * multiplier;
    const discounted = Math.ceil(raw);
    const original = basePrice * qty;

    // Format as euros
    const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + '€';
    const fmtSavings = (cents) => Math.round(cents / 100) + '€';


    const priceEl = card.querySelector('.product-quantity__price');
    const ogPriceEl = card.querySelector('.product-quantity__og-price');

    if (priceEl) priceEl.textContent = fmt(discounted);

    if (discount > 0) {
      if (ogPriceEl) {
        ogPriceEl.textContent = fmt(original);
        ogPriceEl.style.display = '';
      }
    } else {
      if (ogPriceEl) ogPriceEl.style.display = 'none';
    }



    // Update savings badge
    const badge = card.querySelector('.badgeDiscount');
    if (badge && discount > 0) {
      const savings = original - discounted;
      badge.textContent = `Économisez ${fmtSavings(savings)}`;
    }
  });
});


document.addEventListener('submit', async function (e) {
  const form = e.target;
  if (!form.closest('.productForm')) return;

  e.preventDefault();

  // ✅ ALWAYS read from DOM (not stale FormData)
  const variantId = form.querySelector('input[name="id"]').value;
  const quantity = form.querySelector('[name="quantity"]')?.value || 1;

  const formData = new FormData(form);

  const properties = {};
  for (const [key, value] of formData.entries()) {
    if (key.startsWith('properties[')) {
      properties[key.replace('properties[', '').replace(']', '')] = value;
    }
  }

  try {
    await cartManager.addItem(
      variantId,
      parseInt(quantity, 10),
      properties
    );

    // smoother than RAF + timeout combo
    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('cart:update', {
        detail: { cart: null }
      }));
    });

  } catch (err) {
    console.error('Add to cart failed:', err);
  }
});


/* render js form 
document.addEventListener('mouseover', function (e) {
  const card = e.target.closest('.card-wrapper');
  if (!card) return;

  const placeholder = card.querySelector('.productForm-placeholder');
  if (!placeholder || placeholder.dataset.loading === "true" || placeholder.dataset.loaded === "true") return;

  const handle = placeholder.dataset.handle;
  if (!handle) return;

  placeholder.dataset.loading = "true";

  fetch(`/products/${handle}?section_id=EE-product-card-overlay`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Extract just the section div Shopify wraps it in
      const sectionContent = doc.querySelector('#shopify-section-EE-product-card-overlay');

      if (sectionContent) {
        placeholder.innerHTML = sectionContent.innerHTML;
      } else {
        // Fallback: inject everything (not ideal)
        placeholder.innerHTML = html;
      }

      placeholder.dataset.loaded = "true";
    })
    .catch(err => {
      console.error(err);
      placeholder.dataset.loading = "false";
    });

}, true);*/
function updateBtnPrice(form) {
  const btn = form.querySelector('[data-btn-price]');
  if (!btn) return;

  const activeCard = form.querySelector('.product-quantity__card--active');
  if (!activeCard) return;

  const priceEl = activeCard.querySelector('.product-quantity__price');
  if (!priceEl) return;

  btn.textContent = priceEl.textContent.trim();
}

document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
  updateBtnPrice(form);
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.quantity-preset');
  if (!btn) return;

  const form = btn.closest('form');
  if (!form) return;

  const quantity = Number(btn.dataset.quantity);

  form.querySelectorAll('.quantity-preset').forEach(b => {
    b.classList.remove('product-quantity__card--active');
  });
  btn.classList.add('product-quantity__card--active');

  const input = form.querySelector('input[name="quantity"]');
  if (!input) return;

  input.value = quantity;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));

  updateBtnPrice(form);
});

document.addEventListener('change', function (e) {
  const radio = e.target.closest('[data-use="var-selector"]');
  if (!radio) return;

  const form = radio.closest('form');
  if (!form) return;

  const basePrice = parseInt(radio.dataset.durationPrice, 10);
  if (!basePrice) return;

  const discounts = { 1: 0, 2: 5, 3: 10 };

  form.querySelectorAll('.quantity-preset').forEach(card => {
    const qty = parseInt(card.dataset.quantity, 10);
    const discount = discounts[qty] ?? 0;
    const multiplier = (100 - discount) / 100;

    const raw = basePrice * qty * multiplier;
    const discounted = Math.ceil(raw);
    const original = basePrice * qty;

    const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + '€';
    const fmtSavings = (cents) => Math.round(cents / 100) + '€';

    const priceEl = card.querySelector('.product-quantity__price');
    const ogPriceEl = card.querySelector('.product-quantity__og-price');

    if (priceEl) priceEl.textContent = fmt(discounted);

    if (discount > 0) {
      if (ogPriceEl) {
        ogPriceEl.textContent = fmt(original);
        ogPriceEl.style.display = '';
      }
    } else {
      if (ogPriceEl) ogPriceEl.style.display = 'none';
    }

    const badge = card.querySelector('.badgeDiscount');
    if (badge && discount > 0) {
      const savings = original - discounted;
      badge.textContent = `Économisez ${fmtSavings(savings)}`;
    }
  });

  updateBtnPrice(form); // runs after cards are updated so it reads the correct price
});



/* test differential loading */
function formatMoney(cents, currencySymbol) {
  return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0' + (currencySymbol || '€');
}

function buildForm(product, variantColors = {}) {
  const variant = product.variants[0];
  const currencySymbol = window.Shopify?.currency?.active || '€';


  // Build variants HTML if multiple
  let variantsHTML = '';
  if (product.variants.length > 1) {
    const optionName = product.options?.[0]?.name || '';
    variantsHTML = `
      <div class="varBoxContainer">
        <fieldset class="js product-form__input product-form__input--pill card-variant-picker is-${optionName}">
          <input type="hidden" name="id" value="${variant.id}">
          <legend class="form__label legendCard uppercase">${optionName}</legend>
          ${product.variants.map(v => `
            <input
              data-use="var-selector"
              type="radio"
              id="card-var-${v.id}"
              name="id-${product.id}"
              value="${v.id}"
              data-duration-price="${v.price}"
              data-currency="${currencySymbol}"
              ${v.id === variant.id ? 'checked' : ''}
              ${!v.available ? 'disabled' : ''}
            >
            <label for="card-var-${v.id}" class="product-variant__label is-${handleize(v.option1)}">
              ${variantColors[v.id] ? `<div class="product-variant__dot" style="background: ${variantColors[v.id]}; display: block;"></div>` : ''}
              ${v.option1}
              <span class="visually-hidden label-unavailable">Indisponible</span>
            </label>
          `).join('')}
        </fieldset>
      </div>
    `;
  } else {
    variantsHTML = `<input type="hidden" name="id" value="${variant.id}">`;
  }

  // Build quantity presets
  const discounts = [0, 5, 10];
  const presetsHTML = discounts.map((discount, i) => {
    const qty = i + 1;
    const basePrice = variant.price; // in cents
    const originalTotal = basePrice * qty;
    const discountedTotal = Math.ceil(originalTotal * (1 - discount / 100));
    const savings = originalTotal - discountedTotal;


    const savingsBadge = discount > 0 ? `
      <div class="badgeDiscountBox flex justify-center">
        <div class="badge badgeDiscount uppercase">
          Économisez ${Math.floor(savings / 100)}€
        </div>
      </div>
    ` : '';

    const freeShipping = discountedTotal >= 6500 
      ? `<div class="flex tag">✓ Livraison offerte</div>` 
      : '';

    const ogPrice = discount > 0 
      ? `<div class="product-quantity__og-price">${formatMoney(originalTotal)}</div>` 
      : '';

    return `
      <div class="product-quantity__card quantity-preset ${qty === 2 ? 'product-quantity__card--active' : ''}" data-quantity="${qty}">
        ${savingsBadge}
        <div class="product-quantity__card-content">
          <div>
            <div class="product-quantity__duration">${qty} mois</div>
            <div class="product-quantity__products">${qty} produit${qty > 1 ? 's' : ''}</div>
          </div>
          <div class="product-quantity__item">
            <div>
              <div class="product-quantity__price">${formatMoney(discountedTotal)}</div>
              ${ogPrice}
            </div>
          </div>
          ${freeShipping}
        </div>
      </div>
    `;
  }).join('');

  // Default active preset (2nd one)
  const defaultIndex = 1; // 2nd card (0-based)
  const defaultQty = defaultIndex + 1;
  const defaultDiscount = discounts[defaultIndex];

  const defaultTotal = Math.ceil(
    variant.price * defaultQty * (1 - defaultDiscount / 100)
  );

  return `
    <form id="card-form-${product.id}" class="card-quick-form" data-type="add-to-cart-form">
      <div class="productFormHeader flex justify-between">
        <div class="bold">Options d'achat</div>
        <div class="closeProductForm composition__drawer-close">✕</div>
      </div>

      <legend class="form__label legendCard uppercase">Quantité</legend>
      <div class="quantity-presets product-quantity__wrapper">
        ${presetsHTML}
      </div>

      <input type="hidden" name="quantity" value="2" class="qty-input">

      ${variantsHTML}

      <button type="submit" name="add" class="product-form__submit button button--full-width button--primary">
        ${variant.available ? `Ajouter au panier <span class="dotSep"></span> <span data-btn-price>${formatMoney(defaultTotal)}</span>` : 'Épuisé'}
      </button>
    </form>
  `;
}

// Open form on click
document.addEventListener('click', function(e) {
  const trigger = e.target.closest('.openProductForm');
  if (!trigger) return;

  const wrapper = trigger.closest('.card-wrapper');
  const formEl = wrapper.querySelector('.productForm');
  const overlay = wrapper.querySelector('.productFormOverlay');
  closeAllForms();
  // Already loaded — just show
  if (formEl.dataset.loaded) {
    requestAnimationFrame(() => {
      formEl.classList.add('open');
      overlay.classList.add('is-active');
    });
    return;
  }

  const handle = formEl.dataset.productHandle;

  let variantColors = {};
  try {
    variantColors = JSON.parse(formEl.dataset.variantColors || '{}');
  } catch (err) {
    console.error('Invalid data-variant-colors:', err);
  }

  fetch(`/products/${handle}.js`)
  .then(r => r.json())
  .then(product => {
    formEl.innerHTML = buildForm(product, variantColors);
    formEl.dataset.loaded = 'true';
    initFormEvents(formEl, product); // only once

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        formEl.classList.add('open');
        overlay.classList.add('is-active');
      });
    });
  })
  .catch(err => console.error('Failed to load product form:', err));
});

// Form interaction — quantity presets + variant selection
function initFormEvents(formEl, product) {
  const qtyInput = formEl.querySelector('.qty-input');
  const btnPrice = formEl.querySelector('[data-btn-price]');

  // Quantity preset click
  formEl.querySelectorAll('.quantity-preset').forEach(card => {
    card.addEventListener('click', function() {
      formEl.querySelectorAll('.quantity-preset').forEach(c => c.classList.remove('product-quantity__card--active'));
      this.classList.add('product-quantity__card--active');
      qtyInput.value = this.dataset.quantity;
      updateButtonPrice(formEl, product);
    });
  });

  // Variant selection
  formEl.querySelectorAll('[data-use="var-selector"]').forEach(radio => {
    radio.addEventListener('change', function() {
      const variantId = this.value;
      const variant = product.variants.find(v => v.id == variantId);
      if (variant) {
        formEl.querySelector('[name="id"]').value = variantId;
        updateButtonPrice(formEl, product);
      }
    });
  });

  // Submit — add to cart via AJAX
  
}

function updateButtonPrice(formEl, product) {
  const selectedVariantId = formEl.querySelector('[name="id"]').value;
  const qty = parseInt(formEl.querySelector('.qty-input').value) || 1;
  const variant = product.variants.find(v => v.id == selectedVariantId);
  if (!variant) return;

  const discounts = [0, 5, 10];
  const discount = discounts[qty - 1] || 0;
  const price = Math.ceil(variant.price * qty * (1 - discount / 100));
  const btnPrice = formEl.querySelector('[data-btn-price]');
  if (btnPrice) btnPrice.textContent = (price / 100).toFixed(2).replace('.', ',') + '\u00a0€';
}

function closeAllForms() {
  document.querySelectorAll('.productForm.open').forEach(el => el.classList.remove('open'));
  document.querySelectorAll('.productFormOverlay.is-active').forEach(el => el.classList.remove('is-active'));
}

// Close on overlay or X click
document.addEventListener('click', function(e) {
  if (e.target.closest('.closeProductForm') || e.target.matches('.productFormOverlay')) {
    closeAllForms();
  }
});

document.addEventListener('click', function(e) {
  const openForm = document.querySelector('.productForm.open');
  if (!openForm) return;

  const clickedInsideForm = e.target.closest('.productForm.open');
  const clickedTrigger = e.target.closest('.openProductForm');

  // If click is completely outside → close
  if (!clickedInsideForm && !clickedTrigger) {
    closeAllForms();
  }
});

/* toggle articles auteur */
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.toggle-articles-btn');
  const container = document.querySelector('.articleContainer');

  buttons.forEach(btn => {
    btn.addEventListener('click', function () {
      const isHidden = container.classList.contains('hidden');

      container.classList.toggle('hidden');

      // update ALL buttons text (keep them in sync)
      buttons.forEach(b => {
        b.textContent = isHidden
          ? "Voir moins d'articles"
          : "Voir tous les articles";
      });
    });
  });
});